export default function getPhotos (id) {
  const options = {
    1: ['foto1.jpg', 'foto2.jpg', 'foto3.jpg'],
    2: ['foto4.jpg', 'foto5.jpg', 'foto6.jpg'],
    3: ['foto7.jpg', 'foto8.jpg', 'foto9.jpg'],
    4: ['foto10.jpg', 'foto11.jpg', 'foto12.jpg']
  }
  return options[id]
}
